export default __webpack_public_path__ + "static/media/sc36.0cf850f5.mp4";